/* cl-pdp (boomba): vida do buybox copiado (Ecomus 2.2) dentro da main-product nativa do Shrine.
   - opcoes (radios do variant picker dele) -> variante NOSSA: escreve o id no form nativo (buy_buttons), troca
     preco/compare, rotulo "Size: AA", estado esgotado do botao e a URL (?variant=)
   - galeria em grupos por cor (data-cl-group): mostra o grupo da foto da variante, volta ao 1o slide,
     miniaturas clicaveis (Embla via cl-hdt.js)
   - tabela de medidas: <dialog> abre/fecha
   - acordeoes <details>: abre/fecha com a altura animada como o tema dele */
(function () {
  function money(cents, fmt) {
    var n = (cents / 100).toFixed(2);
    return (fmt || 'R$ {{amount_with_comma_separator}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, n.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/<[^>]*>/g, '');
  }

  function init(root) {
    if (root.__cl) return; root.__cl = 1;
    var dataEl = root.querySelector('[data-cl-product]');
    if (!dataEl) return;
    var P = JSON.parse(dataEl.textContent);
    var formId = root.getAttribute('data-form-id');
    var form = formId && document.getElementById(formId);
    var picker = root.querySelector('cl-hdt-variant-picker');
    var gal = root.querySelector('.hdt-medias-slider');
    var thumbs = root.querySelector('cl-hdt-slider-thumb, [class*="hdt-product-media__thumb"] .hdt-slider');

    function current() {
      if (!picker) return P.variants[0];
      var sel = [];
      picker.querySelectorAll('fieldset').forEach(function (fs, i) {
        var c = fs.querySelector('input[type=radio]:checked');
        sel[i] = c ? c.value : null;
      });
      return P.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); }) || null;
    }

    function syncGroup(v) {
      if (!gal || !v || !v.featured_media) return;
      var mid = String(v.featured_media.id);
      var slide = gal.querySelector('.hdt-slider__slide[data-media-id="' + mid + '"]');
      if (!slide) return;
      var g = slide.getAttribute('data-cl-group');
      [gal, thumbs].forEach(function (s) {
        if (!s) return;
        s.querySelectorAll('.hdt-slider__slide[data-cl-group]').forEach(function (n) {
          if (n.getAttribute('data-cl-group') === g) n.removeAttribute('hidden'); else n.setAttribute('hidden', '');
        });
        var api = s.__clEmbla;
        if (api) { try { api.reInit({ slides: '.hdt-slider__slide:not([hidden])' }); api.scrollTo(0, true); } catch (e) {} }
      });
    }

    function update() {
      var v = current();
      var btn = root.querySelector('[data-cl-atc]');
      if (picker) {
        picker.querySelectorAll('fieldset').forEach(function (fs) {
          var c = fs.querySelector('input[type=radio]:checked');
          var lab = fs.querySelector('[update-value]');
          if (c && lab) lab.textContent = c.value;
        });
      }
      if (!v) {
        if (btn) { btn.disabled = true; var t0 = btn.querySelector('.hdt-btn-atc_text'); if (t0) t0.textContent = 'Unavailable'; }
        return;
      }
      if (form) {
        var inp = form.querySelector('input[name="id"]');
        if (inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        var sel = form.querySelector('select[name="id"]');
        if (sel) sel.value = v.id;
      }
      var pr = root.querySelector('[data-cl-price]');
      if (pr) pr.textContent = money(v.price, P.money);
      var cmp = root.querySelector('[data-cl-cmp]');
      if (cmp) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          cmp.removeAttribute('hidden');
          var m = cmp.querySelector('.hdt-money'); if (m) m.textContent = money(v.compare_at_price, P.money);
        } else cmp.setAttribute('hidden', '');
      }
      if (btn) {
        btn.disabled = !v.available;
        var t = btn.querySelector('.hdt-btn-atc_text'); if (t) t.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      syncGroup(v);
      try { history.replaceState(null, '', P.url + '?variant=' + v.id); } catch (e) {}
    }

    if (picker) picker.addEventListener('change', function (e) { if (e.target.matches('input[type=radio]')) update(); });

    // miniaturas -> slide principal
    if (thumbs && gal) {
      thumbs.addEventListener('click', function (e) {
        var t = e.target.closest('.hdt-slider__slide'); if (!t) return;
        var vis = [].slice.call(thumbs.querySelectorAll('.hdt-slider__slide:not([hidden])'));
        var i = vis.indexOf(t);
        if (gal.__clEmbla && i > -1) gal.__clEmbla.scrollTo(i);
      });
      var hook = function () {
        if (!gal.__clEmbla) return setTimeout(hook, 200);
        gal.__clEmbla.on('select', function () {
          var i = gal.__clEmbla.selectedScrollSnap();
          var vis = [].slice.call(thumbs.querySelectorAll('.hdt-slider__slide:not([hidden])'));
          vis.forEach(function (n, k) { n.classList.toggle('is-thumb-selected', k === i); });
          if (thumbs.__clEmbla) thumbs.__clEmbla.scrollTo(i);
        });
      };
      hook();
    }

    // tabela de medidas
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-cl-chart]');
      if (o) {
        e.preventDefault();
        var d = root.querySelector('dialog.hdt-modal__size-chart');
        if (d) { try { d.showModal(); } catch (x) { d.setAttribute('open', ''); } d.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
        return;
      }
      var c = e.target.closest('[data-cl-chart-close]');
      var dl = e.target.closest('dialog.hdt-modal__size-chart');
      if (c || (dl && e.target === dl)) {
        e.preventDefault();
        var d2 = root.querySelector('dialog.hdt-modal__size-chart');
        if (d2) { d2.classList.remove('is-open'); try { d2.close(); } catch (x) { d2.removeAttribute('open'); } document.documentElement.style.overflow = ''; }
      }
    });

    // "AA fits bra sizes: ..." (bloco omr_fit_size dele) + calculadora "Know your size before buying"
    var EQ = { 'AA': '30B, 32A, 34AA', 'A': '30C, 32B, 34A, 36AA', 'B': '30D, 32C, 34B, 36A', 'C': '30E, 32D, 34C, 36B',
      'D': '30F, 32E, 34D, 36C, 38B', 'E': '30G, 32F, 34E, 36D, 38C, 40B', 'F': '32G, 34F, 36E, 38D,40C, 42B',
      'G': '34G, 36F, 38E, 40D, 42C', 'H': '34H, 36G, 38F, 40E, 42D', 'I': '34I, 36H, 38G, 40F, 42E', 'J': '34J, 36I, 38H, 40G, 42F, 44E',
      'K': '34K, 36J, 38I, 40H, 42G, 44F', 'L': '34L, 36K, 38J, 40I, 42H, 44G', 'M': '34M, 36L, 38K, 40J, 42I, 44H',
      'N': '34N, 36M, 38L, 40K, 42J, 44I', 'O': '34O, 36N, 38M, 40L, 42K, 44J', 'P': '34P, 36O, 38N, 40M, 42L, 44K',
      'Q': '34Q, 36P, 38O, 40N, 42M, 44L', 'R': '34R, 36Q, 38P, 40O, 42N, 44M', 'A/B': '30C, 32B, 34A, 36AA', 'C/D': '30E, 32D, 34C, 36B',
      'DD/E/F': '30G, 32F, 34E, 36D, 38C, 40B', 'G/H': '34G, 36F, 38E, 40D, 42C', 'I/J/K': '34I, 36H, 38G, 40F, 42E' };
    function sizeInput(checked) {
      var fs = picker && [].slice.call(picker.querySelectorAll('fieldset')).find(function (f) { var l = f.querySelector('legend'); return l && /size/i.test(l.textContent); });
      return fs ? (checked ? fs.querySelector('input:checked') : fs) : null;
    }
    function fit() {
      var out = root.querySelector('#sizing-value'); if (!out) return;
      var c = sizeInput(true); if (!c) { out.textContent = ''; return; }
      out.textContent = c.value + ' fits bra sizes: ' + (EQ[c.value] || 'Size not found');
    }
    fit();
    if (picker) picker.addEventListener('change', fit);
    var band = root.querySelector('#bandSize'), cup = root.querySelector('#cupSize'), findBtn = root.querySelector('[find-size-btn]');
    if (band && cup) band.addEventListener('change', function () { cup.disabled = !band.value; });
    if (findBtn) findBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!band.value || !cup.value) return;
      var cups = cup.value.split('/');           // DD/E -> DD ou E (US); DDD/F -> DDD ou F
      var wanted = cups.map(function (c) { return band.value + c; });
      var found = Object.keys(EQ).filter(function (k) { return k.indexOf('/') < 0; }).find(function (k) {
        return EQ[k].replace(/\s/g, '').split(',').some(function (s) { return wanted.indexOf(s) > -1; });
      });
      var res = root.querySelector('[omr-finf-result]'), out = root.querySelector('#boomba-size');
      if (res) res.classList.remove('hdt-hidden');
      if (out) out.textContent = found || 'Contact us for the perfect fit';
      var fs = sizeInput(false);
      if (found && fs) { var r = [].slice.call(fs.querySelectorAll('input')).find(function (i) { return i.value === found; }); if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } }
    });

    // acordeoes do buybox
    root.querySelectorAll('details.hdt-accordion-item').forEach(function (d) {
      var s = d.querySelector('summary'), c = d.querySelector('.hdt-accordion-content');
      if (!s || !c) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          c.style.opacity = '0'; s.setAttribute('aria-expanded', 'false');
          d.removeAttribute('open');
        } else {
          d.setAttribute('open', ''); s.setAttribute('aria-expanded', 'true');
          c.style.transition = 'opacity .3s, transform .3s'; c.style.transform = 'translateY(-6px)';
          requestAnimationFrame(function () { c.style.opacity = '1'; c.style.transform = 'translateY(0)'; });
        }
      });
    });
  }

  function run() { document.querySelectorAll('.cl-pdp').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
